// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer .footer-grid-1 {
  width: 100%;
  flex-wrap: wrap;
  gap: 5px;
  text-align: center;
}
.footer .footer-grid-2 {
  margin-top: 8px;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 5px;
  text-align: center;
}
.footer .footer-grid-2 .footer-text-color {
  color: #6c757d !important;
  white-space: nowrap !important;
}
.footer .footer-grid-2 .footer-icons-hover:hover {
  filter: invert(35%) sepia(45%) saturate(5472%) hue-rotate(348deg) brightness(102%) contrast(101%);
  -webkit-filter: invert(35%) sepia(45%) saturate(5472%) hue-rotate(348deg) brightness(102%) contrast(101%);
}
.footer .footer-grid-3 {
  width: 100%;
  flex-wrap: wrap;
  gap: 5px;
  text-align: center;
}
.footer .footer-rwap-text {
  white-space: nowrap !important;
}`, "",{"version":3,"sources":["webpack://./src/layout/footer/footer.scss"],"names":[],"mappings":"AAIE;EACE,WAAA;EACA,eAAA;EACA,QAAA;EACA,kBAAA;AADJ;AAKE;EACE,eAAA;EACA,WAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,kBAAA;AAHJ;AAKI;EACE,yBAAA;EACA,8BAAA;AAHN;AAOM;EACE,iGAAA;EACA,yGAAA;AALR;AAWE;EACE,WAAA;EACA,eAAA;EACA,QAAA;EACA,kBAAA;AATJ;AAYE;EACE,8BAAA;AAVJ","sourcesContent":["@import \"../../styles/variables\";\n\n\n.footer {\n  .footer-grid-1 {\n    width: 100%;\n    flex-wrap: wrap;\n    gap: 5px;\n    text-align: center;\n\n  }\n\n  .footer-grid-2 {\n    margin-top: 8px;\n    width: 100%;\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: center;\n    gap: 5px;\n    text-align: center;\n\n    .footer-text-color {\n      color: $selected-field-color !important;\n      white-space: nowrap !important;\n    }\n\n    .footer-icons-hover {\n      &:hover {\n        filter: invert(35%) sepia(45%) saturate(5472%) hue-rotate(348deg) brightness(102%) contrast(101%);\n        -webkit-filter: invert(35%) sepia(45%) saturate(5472%) hue-rotate(348deg) brightness(102%) contrast(101%);\n\n      }\n    }\n  }\n\n  .footer-grid-3 {\n    width: 100%;\n    flex-wrap: wrap;\n    gap: 5px;\n    text-align: center;\n  }\n\n  .footer-rwap-text {\n    white-space: nowrap !important;\n  }\n}\n\n// Media Queries\n\n@media screen and (min-width: 750px) {\n  // .footer {\n  //   .footer-grid {\n  //     .wrap-text {\n  //       white-space: nowrap !important;\n  //       margin: 2px;\n  //     }\n  //   }\n  // }\n}\n\n@media screen and (min-width:670px) {\n  // .footer {\n  //   display: flex;\n  //   flex-direction: column;\n  // }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
